<div class="authentication-wrapper d-flex justify-content-center align-items-center min-vh-100">
  <div class="authentication-inner w-100">
    
    <!-- Confirm Account Card -->
    <div class="card mx-auto shadow-lg" style="max-width: 550px;">
      <div class="card-body p-5">
        
        <!-- Logo -->
        <div class="text-center mb-4">
          <img src="assets/images/logo1.png" alt="Learnify" class="app-brand-logo mb-3" width="180">
        </div>
        
        <!-- Header -->
        <div class="text-center mb-4">
          <h3 class="mb-3 text-primary fw-bold">¡Bienvenido a Learnify!</h3>
          <h5 class="mb-2 text-dark">Confirma tu cuenta</h5>
          <p class="text-muted">
            Establece una contraseña segura para completar el registro de tu cuenta
          </p>
        </div>

        <!-- ✅ ELIMINADO: Security Alert -->

        <!-- Form -->
        <form [formGroup]="confirmForm" (ngSubmit)="onSubmit()" class="mb-3">
          
          <!-- Password Field -->
          <div class="mb-3">
            <label for="password" class="form-label">Crea una Contraseña <span class="text-danger">*</span></label>
            <div class="input-group input-group-merge">
              <input
                type="{{ showPassword ? 'text' : 'password' }}"
                class="form-control"
                id="password"
                formControlName="password"
                placeholder="Ingresa tu contraseña"
                [class.is-invalid]="hasError('password')"
                autocomplete="new-password">
              <span class="input-group-text cursor-pointer" (click)="togglePasswordVisibility()">
                <i class="fas {{ showPassword ? 'fa-eye-slash' : 'fa-eye' }}"></i>
              </span>
            </div>
            <div *ngIf="hasError('password')" class="invalid-feedback d-block">
              {{ getErrorMessage('password') }}
            </div>
          </div>

          <!-- Password Strength Indicator -->
          <div class="mb-3" *ngIf="confirmForm.get('password')?.value">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <small class="text-muted">Fortaleza de contraseña:</small>
              <small class="text-{{ getPasswordStrengthClass() }}">
                <strong>{{ getPasswordStrengthText() }}</strong>
              </small>
            </div>
            <div class="progress mb-2" style="height: 6px;">
              <div 
                class="progress-bar bg-{{ getPasswordStrengthClass() }}" 
                role="progressbar" 
                [style.width.%]="passwordStrengthScore">
              </div>
            </div>
            
            <!-- Password Requirements -->
            <div class="password-requirements">
              <small class="d-block mb-1" [class.text-success]="passwordRequirements.minLength" 
                     [class.text-muted]="!passwordRequirements.minLength">
                <i class="fas {{ passwordRequirements.minLength ? 'fa-check' : 'fa-times' }} me-1"></i>
                Mínimo 8 caracteres
              </small>
              <small class="d-block mb-1" [class.text-success]="passwordRequirements.hasUppercase" 
                     [class.text-muted]="!passwordRequirements.hasUppercase">
                <i class="fas {{ passwordRequirements.hasUppercase ? 'fa-check' : 'fa-times' }} me-1"></i>
                Una letra mayúscula
              </small>
              <small class="d-block mb-1" [class.text-success]="passwordRequirements.hasLowercase" 
                     [class.text-muted]="!passwordRequirements.hasLowercase">
                <i class="fas {{ passwordRequirements.hasLowercase ? 'fa-check' : 'fa-times' }} me-1"></i>
                Una letra minúscula
              </small>
              <small class="d-block mb-1" [class.text-success]="passwordRequirements.hasNumber" 
                     [class.text-muted]="!passwordRequirements.hasNumber">
                <i class="fas {{ passwordRequirements.hasNumber ? 'fa-check' : 'fa-times' }} me-1"></i>
                Un número
              </small>
              <small class="d-block mb-1" [class.text-success]="passwordRequirements.hasSpecialChar" 
                     [class.text-muted]="!passwordRequirements.hasSpecialChar">
                <i class="fas {{ passwordRequirements.hasSpecialChar ? 'fa-check' : 'fa-times' }} me-1"></i>
                Un carácter especial (!&#64;#$%^&*)
              </small>
            </div>
          </div>

          <!-- Confirm Password Field -->
          <div class="mb-3">
            <label for="confirmPassword" class="form-label">Confirmar Contraseña <span class="text-danger">*</span></label>
            <div class="input-group input-group-merge">
              <input
                type="{{ showConfirmPassword ? 'text' : 'password' }}"
                class="form-control"
                id="confirmPassword"
                formControlName="confirmPassword"
                placeholder="Confirma tu contraseña"
                [class.is-invalid]="hasError('confirmPassword') || hasPasswordMismatch()"
                autocomplete="new-password">
              <span class="input-group-text cursor-pointer" (click)="toggleConfirmPasswordVisibility()">
                <i class="fas {{ showConfirmPassword ? 'fa-eye-slash' : 'fa-eye' }}"></i>
              </span>
            </div>
            <div *ngIf="hasError('confirmPassword')" class="invalid-feedback d-block">
              {{ getErrorMessage('confirmPassword') }}
            </div>
            <div *ngIf="hasPasswordMismatch()" class="invalid-feedback d-block">
              Las contraseñas no coinciden
            </div>
          </div>


          <!-- Submit Button -->
          <button 
            type="submit" 
            class="btn btn-primary-custom btn-lg d-grid w-100 mb-4"
            [disabled]="confirmForm.invalid || isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
            <i *ngIf="!isLoading" class="fas fa-check-circle me-2"></i>
            {{ isLoading ? 'Activando cuenta...' : 'Activar Mi Cuenta' }}
          </button>

        </form>

        

      </div>
    </div>
    
  </div>
</div>
